export default {
  MAIN: 'main',
  GENERAL: 'general',
  IMPORTANT: 'important',
};



// WEBPACK FOOTER //
// ./src/variables/itineraryTextTypes.js